import { Mongo } from "meteor/mongo";
import SimpleSchema from "simpl-schema";

export const ApplicationsCollection = new Mongo.Collection("applications");

export const ApplicationSchema = new SimpleSchema({
    firstName: String,
    middleName: { type: String, optional: true },
    lastName: String,
    dateOfBirth: String,
    phoneNumber: String,
    emailAddress: String,
    streetAddress: String,
    addressLine2: { type: String, optional: true },
    city: String,
    province: String,
    postalCode: String,
    employer: String,
    employerPhoneNumber: String,
    incomeType: String,
    transactionType: String,
    privacyConsent: Boolean,
    status: String,
    statusUpdatedAt: Date,
    assignedTo: { type: String, optional: true },
    notes: { type: Array, optional: true },
    "notes.$": { type: Object, blackbox: true },
    createdAt: Date,
    updatedAt: Date,
});

export function normalizeApplicationDoc(doc) {
    return {
        firstName: doc.firstName?.trim() || "",
        middleName: doc.middleName?.trim() || "",
        lastName: doc.lastName?.trim() || "",
        dateOfBirth: doc.dateOfBirth?.trim() || "",
        phoneNumber: doc.phoneNumber?.trim() || "",
        emailAddress: doc.emailAddress?.trim() || "",
        streetAddress: doc.streetAddress?.trim() || "",
        addressLine2: doc.addressLine2?.trim() || "",
        city: doc.city?.trim() || "",
        province: doc.province?.trim() || "",
        postalCode: doc.postalCode?.trim().toUpperCase() || "",
        employer: doc.employer?.trim() || "",
        employerPhoneNumber: doc.employerPhoneNumber?.trim() || "",
        incomeType: doc.incomeType,
        transactionType: doc.transactionType,
        privacyConsent: Boolean(doc.privacyConsent),
    };
}
